import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class EmpPerformanceSf6Provider {

  module: string = '';
  model: string = 'sf6s/empperformance';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello Emp Performance SF6 Provider');
  }

  listing(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listing";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/emp-performance-sf6.api.ts